// Item type definitions for silver jewelry inventory system

export enum Currency {
  TRY = 'TRY',
  USD = 'USD'
}

export enum ItemType {
  SILVER = 'silver',
  WATCH = 'watch',
  SERVICE = 'service', // Add new item type for services like repairs
}

export enum ItemStatus {
  AVAILABLE = 'available',
  SOLD = 'sold',
}

// Exchange rate record stored in Firestore
export interface ExchangeRate {
  id: string;
  date: Date;
  usdToTry: number;
  createdAt: Date;
  updatedAt: Date;
}

// Base item interface for all inventory items
export interface BaseItem {
  id: string;
  userId: string;
  barcode: string;
  name: string;
  category: string;
  costPerUnit: number;
  costCurrency: Currency;
  costExchangeRateToTry?: number;  // Rate at time of purchase if cost is in USD
  sellPerUnit: number;
  sellCurrency: Currency;
  purchaseDate?: Date;  // Date of purchase, used for historical exchange rates
  status: ItemStatus;
  soldAt?: Date;
  soldExchangeRateToTry?: number;  // Rate at time of sale if sold item had USD price
  createdAt: Date;
  updatedAt: Date;
}

// Specialized type for Silver Items
export interface SilverItem extends BaseItem {
  type: ItemType.SILVER;
  weight: number;               // in grams
  pricePerGram: number;         // entered by user
  costPerGram?: number;         // entered by user
}

// Specialized type for Watches
export interface WatchItem extends BaseItem {
  type: ItemType.WATCH;
  brand?: string;
}

// Union type for inventory items
export type InventoryItem = SilverItem | WatchItem;